/* eslint-disable import/no-extraneous-dependencies */
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { Logging } from '@newrelic/browser-agent/features/logging';

let newrelicObj;
export const initNewRelic = (): void => {
  const { licenseKey, applicationID, accountID } = newRelicConfig;
  const options = {
    init: {
      session_replay: {
        enabled: true,
        block_selector: '',
        mask_text_selector: '*',
        sampling_rate: 10.0,
        error_sampling_rate: 100.0,
        mask_all_inputs: true,
        collect_fonts: true,
        inline_images: false,
        inline_stylesheet: true,
        fix_stylesheets: true,
        mask_input_options: {},
      },
      distributed_tracing: {
        enabled: true,
        cors_use_newrelic_header: true,
        cors_use_tracecontext_headers: true,
        allowed_origins: [globalThis?.app?.env.REACT_APP_API_URL],
      },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: licenseKey,
      applicationID: applicationID,
      sa: 1,
    },
    loader_config: {
      accountID: accountID,
      trustKey: accountID,
      agentID: applicationID,
      licenseKey: licenseKey,
      applicationID: applicationID,
    },
    features: [Logging],
  };
  newrelicObj = new BrowserAgent(options);

  // Set application version from build-time injected config
  const buildVersion = globalThis?.app?.env?.BUILD_VERSION;
  if (buildVersion) {
    newrelicObj.setApplicationVersion(buildVersion);
  }
};

export const newRelicConfig = {
  licenseKey: globalThis?.app?.env.NEW_RELIC_LICENSE_KEY, // Replace with your New Relic Browser license key
  applicationID: globalThis?.app?.env.NEW_RELIC_APPLICATIONID, // Replace with your New Relic Application ID
  accountID: globalThis?.app?.env.NEW_RELIC_ACCOUNTID,
};

export const newrelicAgent = (): BrowserAgent => {
  return newrelicObj;
};

export const setNewRelicApplicationVersion = (version: string): void => {
  newrelicObj?.setApplicationVersion(version);
};
